import React from "react";
import { useTable, useResizeColumns } from "react-table";
import { Row, Col, Table, Spinner, Accordion, Card, Button } from "react-bootstrap";
import Paging from "../_Components/Paging";
import { useFormContext } from "react-hook-form";
import { Avatar } from "@mui/material";
import _ from "lodash";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";

const useStyles = styled({
  pinkAvatar: {
    marginTop: 10,
    marginRight: 2,
    marginBottom: 10,
    color: "#fff",
    width: "22px",
    height: "22px",
    alignItems: "end",
    justifyContent: "center",
  },
});

const changData = (rowData, isCanceledStatus = false) => {
  if (isCanceledStatus) {
    let cancelStatusesArray = [
      { cancelStatus: 1, status: "درخواست_کنسلی", bgColor: "#f64e60", color: "", bdColor: "", count: 0 },
      {
        cancelStatus: 2,
        status: "پیگیری کنسلی",
        bgColor: "#eee5ff",
        color: "#fff",
        bdColor: "transparent",
        count: 0,
      },
      { cancelStatus: 3, status: "رهاسازی کنسلی", bgColor: "#f64e60", color: "", bdColor: "transparent", count: 0 },
      { cancelStatus: 4, status: "کنسل شد", bgColor: "#99260766", color: "", bdColor: "transparent", count: 0 },
      {
        cancelStatus: 5,
        status: "رد درخواست کنسلی",
        bgColor: "#d5950e66",
        color: "",
        bdColor: "transparent",
        count: 0,
      },
    ];

    cancelStatusesArray.map((state) => {
      let count = 0;
      count += _.filter(rowData.basketItemPersons, function (basketItemPersons) {
        return basketItemPersons.cancelStatus == state.cancelStatus && basketItemPersons.cancelStatus != 0;
      }).length;
      state.count = count;
    });

    return (
      <>
        {cancelStatusesArray.map(
          (item) =>
            item.count != 0 && (
              <Avatar
                sx={{ width: 18, height: 18 }}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-custom-class="tooltip-dark"
                title={item.status}
                data-bs-delay-hide="1000"
                // className={classes.pinkAvatar}
                style={{
                  color: item.color != "" && item.color,
                  backgroundColor: item.bgColor,
                  borderColor: item.bdColor != "" && item.bdColor,
                }}
              >
                {item.count}{" "}
              </Avatar>
            ),
        )}
      </>
    );
  } else {
    let statusesArray = [
      { status: "جدید", bgColor: "#3699ff", count: 0 },
      { status: "در_حال_پیگیری", bgColor: "rgb(182 206 232)", count: 0 },
      { status: "رهاسازی", bgColor: "#3699ff", count: 0 },
      { status: "انجام_شده", bgColor: "#40900378", count: 0 },
      { status: "انجام_نشده", bgColor: "#d55e0185", count: 0 },
    ];
    statusesArray.map((state) => {
      let count = 0;

      count += _.filter(rowData.basketItemPersons, function (basketItemPersons) {
        return basketItemPersons.currentStatusS == state.status && basketItemPersons.cancelStatus != 4;
      }).length;

      state.count = count;
    });
    return (
      <>
        {" "}
        {statusesArray.map(
          (item) =>
            item.count != 0 && (
              <Avatar
                sx={{ width: 18, height: 18 }}
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-custom-class="tooltip-dark"
                title={item.status}
                data-bs-delay-hide="1000"
                // className={classes.pinkAvatar}
                style={{ backgroundColor: item.bgColor, fontSize: "11px", color: "white" }}
              >
                {item.count}{" "}
              </Avatar>
            ),
        )}
      </>
    );
  }
};

const DataTable = ({ columns, data, config }) => {
  const { getTableProps, getTableBodyProps, headerGroups, footerGroups, prepareRow, rows } = useTable(
    {
      columns,
      data: data?.data ?? [],
      initialState: { pageIndex: 0 },
    },
    useResizeColumns,
  );
  const [activeKey, setActiveKey] = useState(null); // State for controlling the accordion

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key); // Toggle the accordion
  };

  const methods = useFormContext();

  // const classes = useStyles();

  const showBasketDetail = (prp) => {
    let resDetails = "";
    let jsonparser = JSON?.parse(prp);
    !_.isEmpty(jsonparser) &&
      jsonparser.map((item, index) => {
        if (_.isEmpty(resDetails)) resDetails += item.text;
        else resDetails += " , " + item.text;
      });
    return resDetails != "" ? resDetails : "";
  };
  return (
    <>
      <Row style={methods.formState.isSubmitting ? { opacity: "0.5" } : { opacity: "1" }}>
        <Col xs="12">
          {methods.formState.isSubmitting && (
            <div style={{ position: "absolute", top: "15rem", width: "100%", textAlign: "center", zIndex: "1000" }}>
              <Spinner animation="border" variant="primary" size={400} />
            </div>
          )}
          <div className="bg-white">
            <Table {...getTableProps()} responsive>
              <thead className="border-bottom">
                {headerGroups.map((headerGroup) => {
                  const { key, ...res } = headerGroup.getHeaderGroupProps()
                  return (
                    <tr key={key} {...res}>
                      <td className="p-0" colSpan={11}>
                        <div style={{ paddingRight: "35px" }}>
                          <Table responsive className="mt-1 border-bottom table-acc">
                            <tbody>
                              <tr>
                                {headerGroup.headers.map((column) => {
                                  const { key, ...res } = column.getHeaderProps({
                                    style: {
                                      textAlign: column.align,
                                      minWidth: "100px",
                                      maxWidth: "100px",
                                    },
                                  })
                                  return (
                                    <td
                                      className="text-center"
                                      key={key}
                                      {...res}
                                    >
                                      {column.render("Header")}
                                    </td>
                                  )
                                })}
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  const basket = row.original; // دریافت داده مربوط به سطر جاری
                  const { key, ...res } = row.getRowProps()
                  return (
                    <tr key={i}>
                      <td className="p-0" colSpan={11}>
                        <Accordion onSelect={handleToggle} activeKey={activeKey} className="table-acc border-0">
                          <Card>
                            <Card.Header className="d-flex bg-white">
                              <Button
                                variant="link"
                                onClick={() => handleToggle(row.original.id)}
                                style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                              >
                                <span>{activeKey === row.original.id ? <ExpandLess /> : <ExpandMore />}</span>
                              </Button>
                              <Table {...getTableProps()} responsive className="mt-1  table-acc">
                                <tbody>
                                  <tr key={key} {...res} className="border-0">
                                    {row.cells.map((cell) => {
                                      const { key, ...res } = cell.getCellProps({
                                        className: cell.column.className,
                                      })
                                      return (
                                        <td
                                          className="bg-transparent border-0"
                                          key={key}
                                          {...res}
                                          style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px" }}
                                        >
                                          {cell.render("Cell")}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                </tbody>
                              </Table>
                            </Card.Header>
                            <Accordion.Collapse eventKey={row.original.id}>
                              <Card.Body
                                className="bg-gray  mb-2 py-0 mt-2 rounded-3 highlight-row"
                                style={{ paddingRight: "35px", paddingLeft: "0px" }}
                              >
                                <Table>
                                  <tbody>
                                    {basket?.basketItemTemps?.map((basketItem, index) => (
                                      <tr key={index}>
                                        <td
                                          colSpan={2}
                                          style={{ textAlign: "center", minWidth: "200px", maxWidth: "200px", backgroundColor: "transparent" }}
                                        >
                                          {basketItem.amusementServiceName}
                                        </td>
                                        <td
                                          colSpan={3}
                                          style={{ textAlign: "center", minWidth: "300px", maxWidth: "300px", backgroundColor: "transparent" }}
                                        >
                                          {showBasketDetail(basketItem.details)}
                                        </td>
                                        <td style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px", backgroundColor: "transparent" }}>
                                          {basketItem.checkInDate}
                                        </td>
                                        <td style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px", backgroundColor: "transparent" }}>
                                          {basketItem.basketItemPersonTemps.length} نفر{" "}
                                        </td>
                                        <td style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px", backgroundColor: "transparent" }}>
                                          <div className="d-flex justify-content-center bg-transparent">
                                            {changData(basketItem)}
                                          </div>
                                        </td>
                                        <td style={{ textAlign: "center", minWidth: "100px", maxWidth: "100px", backgroundColor: "transparent" }}>
                                          <div className="d-flex justify-content-center bg-transparent">
                                            {changData(basketItem, true)}
                                          </div>
                                        </td>
                                        <td
                                          colSpan={2}
                                          style={{ textAlign: "center", minWidth: "200px", maxWidth: "200px", backgroundColor: "transparent" }}
                                        ></td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                                {/* {basket?.basketItems?.map((basketItem) => (
                                  <Row className="px-3 py-1" key={basketItem.id}>
                                    <Col>{basketItem.amusementService.name}</Col>
                                    <Col>{basketItem.checkInDate}</Col>
                                    <Col>{basketItem.basketItemPersons.length} نفر </Col>
                                    <Col className="d-flex">{changData(basketItem)}</Col>
                                  </Row>
                                ))}{" "} */}
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                        {/* <Accordion.Item eventKey={i}>
                            <Accordion.Header>

                            </Accordion.Header>
                            <Accordion.Body className="bg-gray  mx-lg-5 mb-2 py-0 mt-2 rounded-3 highlight-row">
                              {basket?.basketItems?.map((basketItem) => (
                                <Row className="px-3 py-1" key={basketItem.id}>
                                  <Col>{basketItem.amusementService.name}</Col>
                                  <Col>{basketItem.checkInDate}</Col>
                                  <Col>{basketItem.basketItemPersons.length} نفر </Col>
                                  <Col className="d-flex">{changData(basketItem)}</Col>
                                </Row>
                              ))}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion> */}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              {config.show_footer && (
                <tfoot style={{ background: "linear-gradient(#dfe0eb,#bbbcc6)" }}>
                  {footerGroups.map((group) => (
                    <tr {...group.getFooterGroupProps()}>
                      {group.headers.map((column) => (
                        <td {...column.getFooterProps()}>{column.render("Footer")}</td>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              )}
            </Table>
            <Paging config={config} {...methods} />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default DataTable;
